<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('fulfillment_ptl_assemble.assemble') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                        <span v-if="shipment_loaded">
                            <v-row class="px-0 py-0" justify="center">
                                <v-col cols="5" class="px-0 pb-3" justify="center" align="center">
                                    <v-autocomplete class="py-0 mr-2 mt-0" v-model="selected_box.id" :items="boxes" :label="$t('fulfillment_ptl_assemble.box')" item-value="id" item-text="name" :rules="rules_required"></v-autocomplete> 
                                </v-col>

                                <v-col cols="5" class="px-0 pb-3" justify="center" align="center">
                                    <v-text-field class="py-0 ml-2 mt-0" v-model="selected_box.quantity" :label="$t('fulfillment_ptl_assemble.quantity')" :rules="numeric_required"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 py-0 mb-1" justify="center" align="center" >
                                <v-col cols="10" justify="center" align="center" class="px-1 py-1" style="text-align: left; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                    {{ $t('fulfillment_ptl_assemble.products') }}
                                </v-col>
                            </v-row>
                            <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                <v-col cols="10" class="py-0">
                                    <v-row class="px-0 py-0 my-0" justify="start" align="start">
                                        <v-col cols="6" justify="center" align="center" class="px-0 py-0" style="display:flex;" v-for="(detail, i) of shipment.shipment_product_detail" :key="i">
                                            <v-card style="width: 100%; height: 160px; display: inline-block;" :class=" i % 2 == 0 ? 'px-2 py-2 ml-0 mr-3 my-2 v-card-dark-theme-shadow' : 'px-2 py-2 ml-3 mr-0 my-2 v-card-dark-theme-shadow'">
                                                <v-row style="margin:auto">
                                                    <img :src="detail.product.image_base64" :alt="$t('fulfillment_ptl_assemble.product_image')" width="120" height="120" style="margin: auto;">
                                                    <h3 style="margin: auto;">{{ detail.product.description }}</h3> 
                                                    <h2 style="margin: auto;">{{detail.quantity}}</h2>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 py-0" justify="center">
                                <v-col class="px-0" cols="10" justify="end" align="end">
                                    <v-btn v-if="shipment_loaded" style="width: 100%;" outlined color="secondary" @click="downloadLabel" :disabled="can_continue">
                                        {{ $t('fulfillment_ptl_assemble.print_label') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </span>
                        
                        <span v-else>
                            <br>
                            <br>
                            <br>
                            <v-row class="px-5 py-0" justify="center">
                                <v-col cols="6" justify="center" align="center">
                                    <p>{{ this.$t('fulfillment_ptl_assemble.scann_tote') }}</p>
                                </v-col>
                            </v-row>
                        </span>

                        <v-row class="px-0 py-0" justify="center">
                            <v-col class="px-0" cols="10" justify="end" align="end">
                                <v-btn class="right px-3 mx-4" @click="cancel" :disabled="can_continue">
                                    {{ $t('fulfillment_ptl_assemble.cancel') }}
                                </v-btn>
                                <v-btn v-if="shipment_loaded" class="right white_highlight--text" color="secondary" @click="save" :disabled="!can_continue">
                                    {{ $t('fulfillment_ptl_assemble.finish') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpBoxRepository } from '../../../boxes/infrastructure/box_repository';
import { HttpShipmentRepository } from '../../infrastructure/shipment_repository';
import { boxIndexUseCase } from '../../../boxes/application/use_cases/box_index_use_case';
import { ptlGetOrderByToteUseCase } from '../../application/use_cases/ptl_get_order_by_tote_use_case';
import { ptlGetLabelUseCase } from '../../application/use_cases/ptl_get_label_use_case';

import printJS from 'print-js'

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        numeric_required(){
            return [
                v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                v => !!v || this.$t('edit_appointment.validations.required_field')
            ];
        },
    },
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            shipment_loaded: false,
            shipment: {
                id: "",
                unique_order_number: "",
                shipping_service: "",
                shipment_product_detail: [],
                client_id: ""
            },
            boxes: [],
            barcode: "",
            can_continue: false,
            selected_box: {
                id: "",
                quantity: ""
            }
        }
    },
    mounted(){
        let self = this; 

        const keyPressHandler = (e) => {
            if(self.last == true && /^\S+$/.test(e.key)) { 
                self.barcode = e.key;
                self.last = false;
            }
            else if(e.code == "Enter") {
                self.last = true;
                self.updateList();
            }
            else if(/^\S+$/.test(e.key)) self.barcode += e.key;
        };

        window.addEventListener ('keypress', keyPressHandler, { capture: true });
        
        this.$once('hook:beforeDestroy',
            () => window.removeEventListener('keypress', keyPressHandler)
        );

        this.index();
        this.$store.state.module = "headers.fulfillment_ptl_assemble";
    },
    methods: {
        async index(){
            try {
                const res = await boxIndexUseCase(HttpBoxRepository);
                this.boxes = res;
            } catch(e){
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        save(){
            this.$router.go(-1);
        },
        cancel(){
            this.$router.go(-1);
        },
        async updateList(){
            if (!/^txx\d+$/.test(this.barcode.toLowerCase())){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t("fulfillment_ptl_assemble.tote_not_valid")
                }

                return
            } 

            try{
                this.shipment = await ptlGetOrderByToteUseCase(this.barcode, HttpShipmentRepository);
                this.shipment_loaded = true;
            }
            catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async downloadLabel(){
            this.can_continue = true;
                
            const box = this.boxes.find(x => {
                if(x.id == this.selected_box.id) return x;
            })

            try{
                const res = await ptlGetLabelUseCase({
                    "id": this.shipment.id,
                    "unique_order_number": this.shipment.unique_order_number,
                    "box_id": box.id,
                    "box_quantity": parseInt(this.selected_box.quantity),
                    "weight": box.volumetricWeight,
                    "client_id": this.shipment.client_id
                }, HttpShipmentRepository);

                printJS({ printable: res.data.success.arguments.images, type: 'image'});

                this.$router.go(-1);
            }
            catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        }
    },
    watch:{
        "selected_box.quantity": function(){
            this.barcode = "";
        }
    }
}
</script>

<style lang="css">
</style>